<template>
  <div class="video-stat">
    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon total">
              <i class="el-icon-video-camera"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.totalVideos || 0 }}</div>
              <div class="stats-label">视频总数</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon published">
              <i class="el-icon-check"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.publishedVideos || 0 }}</div>
              <div class="stats-label">已发布</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon pending">
              <i class="el-icon-clock"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.pendingAudit || 0 }}</div>
              <div class="stats-label">待审核</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon views">
              <i class="el-icon-view"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatNumber(statistics.totalViews || 0) }}</div>
              <div class="stats-label">总播放量</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">视频标题：</span>
            <el-input v-model="searchInfo.title" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">视频状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">发布用户：</span>
            <el-input v-model="searchInfo.username" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">视频分类：</span>
            <el-select v-model="searchInfo.categoryId" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in categoryList" :key="i" :label="item.categoryName" :value="item.categoryId"></el-option>
            </el-select>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-refresh" @click="refreshStats">刷新统计</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="title" label="视频标题" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="coverUrl" label="封面" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.coverUrl"
              :src="scope.row.coverUrl"
              :preview-src-list="[scope.row.coverUrl]"
              style="width: 60px; height: 40px; border-radius: 4px;"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="username" label="发布用户" width="120"></el-table-column>
        <el-table-column prop="categoryName" label="分类" width="100"></el-table-column>
        <el-table-column prop="duration" label="时长" width="80">
          <template slot-scope="scope">
            {{ formatDuration(scope.row.duration) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="viewCount" label="播放量" width="100">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: 500;">{{ formatNumber(scope.row.viewCount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="likeCount" label="点赞量" width="80">
          <template slot-scope="scope">
            <span style="color: #67C23A;">{{ scope.row.likeCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="commentCount" label="评论量" width="80">
          <template slot-scope="scope">
            <span style="color: #E6A23C;">{{ scope.row.commentCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('video:view')" @click="viewDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" v-if="$can('video:audit') && scope.row.status === 0" @click="auditVideo(scope.row, 1)">通过</el-button>
            <el-button type="text" size="small" v-if="$can('video:audit') && scope.row.status === 0" @click="auditVideo(scope.row, 3)" style="color: #F56C6C;">拒绝</el-button>
            <el-button type="text" size="small" v-if="$can('video:delete')" @click="confirmDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 视频详情弹窗 -->
    <el-dialog
      title="视频详情"
      :visible.sync="videoDetailVisible"
      width="800px"
      :before-close="handleClose">
      <div v-if="videoDetail">
        <div class="video-detail">
          <div class="video-preview">
            <div class="video-cover">
              <el-image
                v-if="videoDetail.coverUrl"
                :src="videoDetail.coverUrl"
                style="width: 200px; height: 120px; border-radius: 8px;"
                fit="cover"
              />
            </div>
            <div class="video-info">
              <h3>{{ videoDetail.title }}</h3>
              <p class="description">{{ videoDetail.description }}</p>
              <div class="meta-info">
                <el-tag>{{ videoDetail.categoryName }}</el-tag>
                <span class="duration">时长: {{ formatDuration(videoDetail.duration) }}</span>
                <span class="resolution">分辨率: {{ videoDetail.resolution }}</span>
              </div>
            </div>
          </div>

          <el-form label-width="100px" class="detail-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="发布用户:">{{ videoDetail.username }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="文件格式:">{{ videoDetail.format }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="文件大小:">{{ formatFileSize(videoDetail.fileSize) }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="视频状态:">
                  <el-tag :type="getStatusTagType(videoDetail.status)">
                    {{ getStatusText(videoDetail.status) }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="播放量:">{{ formatNumber(videoDetail.viewCount) }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="点赞量:">{{ videoDetail.likeCount || 0 }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="评论量:">{{ videoDetail.commentCount || 0 }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="创建时间:">{{ videoDetail.createTime }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发布时间:">{{ videoDetail.publishTime || '未发布' }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="videoDetail.auditInfo">
              <el-col :span="24">
                <el-form-item label="审核信息:">
                  <div class="audit-info">
                    <p>审核员: {{ videoDetail.auditInfo.auditorName }}</p>
                    <p>审核时间: {{ videoDetail.auditInfo.auditTime }}</p>
                    <p>审核备注: {{ videoDetail.auditInfo.auditRemark }}</p>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="视频审核"
      :visible.sync="auditDialogVisible"
      width="500px">
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="审核结果:">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核备注:">
          <el-input
            v-model="auditForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入审核备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAudit">确定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  export default {
    name: "video-stat",
    data () {
      return {
        // 统计数据
        statistics: {
          totalVideos: 0,
          publishedVideos: 0,
          pendingAudit: 0,
          rejectedVideos: 0,
          totalViews: 0,
          totalLikes: 0
        },
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        // 弹窗控制
        videoDetailVisible: false,
        auditDialogVisible: false,
        videoDetail: null,
        // 审核表单
        auditForm: {
          id: null,
          status: 1,
          remark: ''
        },
        // 搜索条件
        searchInfo: {
          title: '',
          status: '',
          username: '',
          categoryId: '',
          startDate: '',
          endDate: '',
          pageNumber: 1,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '待审核', value: 0 },
          { label: '已发布', value: 1 },
          { label: '已下架', value: 2 },
          { label: '审核拒绝', value: 3 },
          { label: '用户删除', value: 4 }
        ],
        categoryList: [],
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.title'(newVal){
        if (newVal === ""){
          this.getVideoList();
        }
      },
      'searchInfo.username'(newVal){
        if (newVal === ""){
          this.getVideoList();
        }
      },
      'searchDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getVideoList();
        }
      },
    },
    created() {
      this.getVideoList();
      this.getStatistics();
      this.getCategoryList();
    },
    methods: {
      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 1;
        this.getVideoList();
      },

      // 刷新统计数据
      refreshStats() {
        this.getStatistics();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val;
        this.getVideoList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 1;
        this.getVideoList();
      },

      // 获取视频列表
      getVideoList() {
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }

        if (this.loading) return;
        this.loading = true;

        axios.get('/admin/video/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      // 获取统计数据
      getStatistics() {
        axios.get('/admin/video/statistics', {
          params: { period: 'month' }
        }).then(result => {
          if (result.code === 200) {
            this.statistics = result.data;
          }
        }).catch(err => {
          console.error('获取统计数据失败:', err);
        });
      },

      // 获取分类列表
      getCategoryList() {
        axios.get('/admin/category/list').then(result => {
          if (result.code === 200) {
            this.categoryList = result.data;
          }
        }).catch(err => {
          console.error('获取分类列表失败:', err);
        });
      },

      // 查看视频详情
      viewDetail(row) {
        this.getVideoDetail(row.id);
      },

      // 获取视频详情
      getVideoDetail(id) {
        axios.get(`/admin/video/${id}`).then(result => {
          if (result.code === 200) {
            this.videoDetail = result.data;
            this.videoDetailVisible = true;
          } else {
            this.$message.error('获取视频详情失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 审核视频
      auditVideo(row, status) {
        this.auditForm.id = row.id;
        this.auditForm.status = status;
        this.auditForm.remark = '';
        this.auditDialogVisible = true;
      },

      // 提交审核
      submitAudit() {
        if (this.auditForm.status === 3 && !this.auditForm.remark) {
          this.$message.warning('拒绝审核需要填写备注');
          return;
        }

        axios.put(`/admin/video/${this.auditForm.id}/status`, {
          status: this.auditForm.status,
          remark: this.auditForm.remark
        }).then(result => {
          if (result.code === 200) {
            this.$message.success('审核成功');
            this.auditDialogVisible = false;
            this.getVideoList();
            this.getStatistics();
          } else {
            this.$message.error(result.message || '审核失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 删除视频
      confirmDelete(row) {
        this.$confirm(`确定要删除视频"${row.title}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteVideo(row.id);
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      deleteVideo(id) {
        axios.delete(`/admin/video/${id}`).then(result => {
          if (result.code === 200) {
            this.$message.success('删除成功');
            this.getVideoList();
            this.getStatistics();
          } else {
            this.$message.error(result.message || '删除失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.videoDetail = null;
        done();
      },

      // 工具方法
      formatDuration(seconds) {
        if (!seconds) return '0秒';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hours > 0) {
          return `${hours}小时${minutes}分钟${secs}秒`;
        } else if (minutes > 0) {
          return `${minutes}分钟${secs}秒`;
        } else {
          return `${secs}秒`;
        }
      },

      formatNumber(num) {
        if (!num) return '0';
        if (num >= 10000) {
          return (num / 10000).toFixed(1) + '万';
        }
        return num.toString();
      },

      formatFileSize(size) {
        if (!size) return '0B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let index = 0;
        while (size >= 1024 && index < units.length - 1) {
          size /= 1024;
          index++;
        }
        return Math.round(size * 100) / 100 + units[index];
      },

      getStatusText(status) {
        const statusMap = {
          0: '待审核',
          1: '已发布',
          2: '已下架',
          3: '审核拒绝',
          4: '用户删除'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          0: 'warning',
          1: 'success',
          2: 'info',
          3: 'danger',
          4: 'info'
        };
        return typeMap[status] || 'info';
      }
    }
  }
</script>
<style lang="less" scoped>
  .video-stat {
    .stats-cards {
      margin-bottom: 20px;

      .stats-card {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 16px;

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          margin-right: 16px;

          &.total {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
          &.published {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }
          &.pending {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }
          &.views {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }
        }

        .stats-content {
          .stats-number {
            font-size: 28px;
            font-weight: bold;
            color: #333;
            line-height: 1;
          }
          .stats-label {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
          }
        }
      }
    }
  }

  .video-detail {
    .video-preview {
      display: flex;
      margin-bottom: 20px;

      .video-cover {
        margin-right: 20px;
      }

      .video-info {
        flex: 1;

        h3 {
          margin: 0 0 10px 0;
          color: #333;
          font-size: 18px;
        }

        .description {
          color: #666;
          line-height: 1.5;
          margin-bottom: 15px;
        }

        .meta-info {
          display: flex;
          align-items: center;
          gap: 15px;

          .duration, .resolution {
            color: #999;
            font-size: 14px;
          }
        }
      }
    }

    .detail-form {
      .el-form-item {
        margin-bottom: 12px;
      }
    }

    .audit-info {
      background: #f5f7fa;
      padding: 15px;
      border-radius: 4px;

      p {
        margin: 5px 0;
        color: #606266;
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .video-stat .stats-cards {
      .el-col {
        margin-bottom: 16px;
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }
</style>
